export var Constants = {
  URL_API: "/services/productfamilypage",
  PAGINATIONS: {
    SELECTOR: "js-pagination"
  },
  PRODUCT_LIST_SELECTORS: {
    CONTAINER: "js-list-container",
    EMPTY_LIST_ELM: "js-empty-list",
    CONTENT: "js-list-content",
    PRODUCTS: "js-list-products"
  },
  ACTION: {
    SORT: "sort",
    PAGINATE: "paginate",
    FILTER: "filter",
    RESET_FILTERS: "resetFilters"
  },
  FILTERS_FORM_SELECTOR: "js-form-filters",
  FILTERS_FORM_CONTAINER_SELECTOR: "js-filter-form-container",
  FILTERS_LAYER_CLOSE_BUTTON: "js-filters-layer-close-button",
  PEDAGOGICAL_FILTERS: {
    SELECTOR: "js-pedagogical-filters-form",
    VALIDATE_BUTTON: "js-filters-validate-pedagogical-filters-button",
    RESET_BUTTON: "js-filters-reset-pedagogical-filters-button",
    SKIP_BUTTON: "js-filters-skip-pedagogical-filters-button",
    PREVIOUS_BUTTON: "js-filters-previous-pedagogical-filters-button",
    DESCRIPTION_MODAL: {
      CONTENT: "js-pedagogical-filter-description-modal",
      OPEN_BUTTON: "js-pedagogical-filter-description-modal-open-button",
      CLOSE_BUTTON: "js-pedagogical-filter-description-modal-close-button"
    },
    ACTIONS: {
      VALIDATE: "VALIDATE",
      SKIP: "SKIP",
      BACK: "BACK",
      REMOVE_PEDAGOGICAL_FILTER_VALUE: "removePedagogicalFilterValue",
      RESET: "reset"
    }
  },
  SWIPER_PEDAGOGICAL_FILTERS: {
    SELECTOR: "js-pedago-filters-swiper"
  }
};